import { auth, db } from './client';
import * as authService from './authService';
import * as coinsService from './coinsService';
import * as metalPricesService from './metalPricesService';
import * as visitorService from './visitorService';
import * as adminService from './adminService';
import * as storageService from './storageService';
import * as purchaseService from './purchaseService';

export function createFirebaseServices() {
  return {
    auth,
    db,
    createRecaptchaVerifier: authService.createRecaptchaVerifier,
    setPhoneAuthTestMode: authService.setPhoneAuthTestMode,
    googleProvider: authService.googleProvider,
    facebookProvider: authService.facebookProvider,
    twitterProvider: authService.twitterProvider,
    onAuthUserListener: authService.createAuthUserListener,
    fetchAuthUserProfile: authService.fetchAuthUserProfile,
    doCreateUserWithEmailAndPassword: authService.doCreateUserWithEmailAndPassword,
    doSignInWithEmailAndPassword: authService.doSignInWithEmailAndPassword,
    doSignInWithGoogle: authService.doSignInWithGoogle,
    doSignInWithFacebook: authService.doSignInWithFacebook,
    doSignInWithTwitter: authService.doSignInWithTwitter,
    doSignOut: authService.doSignOut,
    doPasswordReset: authService.doPasswordReset,
    doSendEmailVerification: authService.doSendEmailVerification,
    doPasswordUpdate: authService.doPasswordUpdate,
    fetchSignInMethods: authService.fetchSignInMethods,
    doLinkWithPopup: authService.doLinkWithPopup,
    doLinkWithEmailPassword: authService.doLinkWithEmailPassword,
    doUnlinkProvider: authService.doUnlinkProvider,
    doDeleteCurrentUser: authService.doDeleteCurrentUser,
    getFriendlyAuthError: authService.getFriendlyAuthError,
    deleteMessages: authService.deleteMessages,
    initializeRecaptchaConfig: authService.initializeRecaptchaConfig,
    signInWithPhoneNumber: (phoneNumber, appVerifier) =>
      authService.signInWithPhoneNumber(auth, phoneNumber, appVerifier),
    addCoin: coinsService.addCoin,
    fetchCoinTypes: coinsService.fetchCoinTypes,
    lookupUserByPhone: coinsService.lookupUserByPhone,
    transferCoin: coinsService.transferCoin,
    createCoinProduct: coinsService.createCoinProduct,
    saveCoinProduct: coinsService.saveCoinProduct,
    updateCoinProductImageFront: coinsService.updateCoinProductImageFront,
    fetchCoinMinters: coinsService.fetchCoinMinters,
    fetchMintNamesFromProducts: coinsService.fetchMintNamesFromProducts,
    createCoinMinter: coinsService.createCoinMinter,
    fetchUser: coinsService.fetchUserByPhone,
    fetchProduct: coinsService.fetchProduct,
    fetchCoin: coinsService.fetchCoin,
    fetchCoinWithOwner: coinsService.fetchCoinWithOwner,
    fetchCoinProducts: coinsService.fetchCoinProducts,
    fetchCoinProductsPage: coinsService.fetchCoinProductsPage,
    fetchCoins: coinsService.fetchCoinsForOwner,
    countCoinsForOwner: coinsService.countCoinsForOwner,
    fetchCoinsPage: coinsService.fetchCoinsPageForOwner,
    coin: coinsService.coinDocRef,
    user: authService.userApi,
    users: authService.usersCollection,
    saveUserProfile: authService.saveUserProfile,
    removeOwnAccount: authService.removeOwnAccount,
    fetchAllUsers: authService.fetchAllUsers,
    fetchUsersPage: authService.fetchUsersPage,
    getMetalPrice: metalPricesService.getMetalPrice,
    getMetalPrices: metalPricesService.getMetalPrices,
    grantCoinVisitorAccess: visitorService.grantCoinVisitorAccess,
    listSharedCoinViews: visitorService.listSharedCoinViews,
    listCoinVisitors: visitorService.listCoinVisitors,
    revokeCoinVisitorAccess: visitorService.revokeCoinVisitorAccess,
    listUnassignedCoins: adminService.listUnassignedCoins,
    sellCoin: adminService.sellCoin,
    removeUser: adminService.removeUser,
    uploadCoinProductImage: storageService.uploadCoinProductImage,
    downloadCoinProductImage: storageService.downloadCoinProductImage,
    getCatalogStockStatus: purchaseService.getCatalogStockStatus,
    checkPurchaseAvailability: purchaseService.checkPurchaseAvailability,
    getPurchaseQuote: purchaseService.getPurchaseQuote,
    joinCoinPurchaseWaitlist: (coinProductId, options) =>
      purchaseService.joinCoinPurchaseWaitlist(coinProductId, options),
    createCoinCheckoutSession: purchaseService.createCoinCheckoutSession,
    getPurchaseStatus: purchaseService.getPurchaseStatus,
  };
}
